import i18n from '@/i18n/translations';

import AllSuccessModal from './dependencies/modals/AllSuccessModal';
import AnyOrders from './dependencies/modals/AnyOrders';
import NotAllSuccessModal from './dependencies/modals/NotAllSuccessModal';

export enum Status {
  CONFIRMED = 'confirmed',
  PAYMENT_REQUIRED = 'payment_required',
  PAYMENT_IN_PROCESS = 'payment_in_process',
  PARTIALLY_PAID = 'partially_paid',
  PAID = 'paid',
  PARTIALLY_REFUNDED = 'partially_refunded',
  PENDING_CANCEL = 'pending_cancel',
  CANCELLED = 'cancelled',
}

export const getStatusLabel = (status: string) => {
  return i18n.t(`commonGeneral:status.${status}`, { defaultValue: status });
};

export const getBgStatus = (status: string) => {
  switch (status) {
    case 'confirmed':
      return '#FFF9E6';
    case 'payment_required':
      return '#FFF3CD';
    case 'payment_in_process':
      return '#D1ECF1';
    case 'partially_paid':
      return '#FFE5CC';
    case 'paid':
      return '#D6F2DF';
    case 'partially_refunded':
      return '#E8DAEF';
    case 'pending_cancel':
      return '#F8D7DA';
    case 'cancelled':
      return '#F6DDDC';
    default:
      return '#F8F9FA';
  }
};

export const getLbColorStatus = (status: string) => {
  switch (status) {
    case 'confirmed':
      return '#F39C12';
    case 'payment_required':
      return '#E67E22';
    case 'payment_in_process':
      return '#3498DB';
    case 'partially_paid':
      return '#E67E22';
    case 'paid':
      return '#27AE60';
    case 'partially_refunded':
      return '#8E44AD';
    case 'pending_cancel':
      return '#E74C3C';
    case 'cancelled':
      return '#C0392B';
    default:
      return '#95A5A6'; // Gris
  }
};

export const filters = [
  {
    width: '220px',
    filterName: 'status',
    items: [
      { value: Status.CONFIRMED },
      { value: Status.PAYMENT_REQUIRED },
      { value: Status.PAYMENT_IN_PROCESS },
      { value: Status.PARTIALLY_PAID },
      { value: Status.PAID },
      { value: Status.PARTIALLY_REFUNDED },
      { value: Status.PENDING_CANCEL },
      { value: Status.CANCELLED },
    ],
  },
];

export const getGenerateGuidesModal = (
  isOpen: boolean,
  onClose: () => void,
  failedOrders?: string[],
  successTrackingIds?: string[],
) => {
  const noOrdersProcessed =
    (!successTrackingIds || successTrackingIds.length === 0) &&
    (!failedOrders || failedOrders.length === 0);

  if (noOrdersProcessed) {
    return (
      <AnyOrders
        isOpen={isOpen}
        onClose={onClose}
        message="No hay órdenes pendientes para procesar"
      />
    );
  }

  if (failedOrders && failedOrders.length > 0) {
    return <NotAllSuccessModal isOpen={isOpen} onClose={onClose} orders={failedOrders} />;
  }

  return (
    <AllSuccessModal
      isOpen={isOpen}
      onClose={onClose}
      successTrackingIds={successTrackingIds || []}
    />
  );
};

export const randomModal = (isOpen: boolean, onClose: () => void) => {
  const modals = [
    <AllSuccessModal
      isOpen={isOpen}
      onClose={onClose}
      successTrackingIds={['99M123456', '99M789012']}
    />,
    <AnyOrders isOpen={isOpen} onClose={onClose} />,
    <NotAllSuccessModal isOpen={isOpen} onClose={onClose} orders={['1', '2', '3']} />,
  ];
  return modals[Math.floor(Math.random() * modals.length)];
};
